var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras1 && _vm.extras1.formBgWap)?_c('div',{staticClass:"m-wrap m-wap"},[_c('Banner',{attrs:{"seminarInfo":_vm.seminarInfo}}),(_vm.preview || _vm.formInfo.status == 1 || _vm.isSetting == 1)?_c('div',{style:({
      background:
        _vm.extras.formFieldBg.colorOrBg == 'color'
          ? _vm.extras.formFieldBg.color
          : 'url(' + _vm.extras.formFieldBg.src + ')',
      'background-size': '100% 100%',
    })},[(_vm.extras.formTitle.display == 1)?_c('h4',{staticClass:"title",class:_vm.extras.formTitle.textAlign,style:({ 'letter-spacing': _vm.extras.formTitle.wordWidth + 'px' })},[_vm._v(" "+_vm._s(_vm.extras.formTitle.title)+" ")]):_vm._e(),_c('CField',{staticClass:"field-wrap",attrs:{"formData":_vm.formData,"platform":_vm.platform}}),_c('div',{staticClass:"bottom"},[_c('a-button',{staticClass:"submit",style:({
          color:
            _vm.extras.submitButton.buttonTextStyle == 'custom'
              ? _vm.extras.submitButton.fontColor
              : '',

          'font-style':
            _vm.extras.submitButton.buttonTextStyle == 'custom'
              ? _vm.extras.submitButton.fontTilt == 'on'
                ? 'italic'
                : 'normal'
              : '',
          'font-weight':
            _vm.extras.submitButton.buttonTextStyle == 'custom'
              ? _vm.extras.submitButton.fontWeight == 'on'
                ? 'bolder'
                : ''
              : '',
        }),attrs:{"type":"primary","disabled":_vm.isSubmitting},on:{"click":function($event){return _vm.submit()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"submitButton.text"))+" ")]),(_vm.extras.seminarButton && _vm.extras.seminarButton.display == 1)?_c('a-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.formInfo.identity == 1),expression:"formInfo.identity == 1"}],staticClass:"verify",attrs:{"disabled":_vm.isSubmitting},on:{"click":function($event){return _vm.togoVerifyNew()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"seminarButton.text"))+" ")]):_vm._e()],1)],1):_c('FormStatus',{attrs:{"status":_vm.formInfo.status == 0 ? 'nostart' : 'over',"platform":_vm.platform}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }